export const STATUS = {
	UPCOMING: -1,
	IN_PROGRESS: 0,
	COMPLETED: 1,
	SKIPPED: 2
}
